import { createResponsiveStateReducer } from 'redux-responsive'

export default createResponsiveStateReducer(
  {
    xs: 575,
    sm: 767,
    md: 1023,
    lg: 1439,
    xl: 1919,
  },
  {
    infinity: 'xxl',
  }
)

export const sIsSM = state => state.browser.lessThan.md
export const sIsMD = state => state.browser.lessThan.lg
export const sIsLG = state => state.browser.lessThan.xl

export const sIsMobile = state => state.browser.lessThan.sm

export const sBrowser = state => state.browser
